module.exports = ".user-input {\n  text-align: left !important;\n  font-size: 24px;\n  font-weight: 900;\n  color: #009fe7;\n  display: block;\n}\n.btn-invite {\n  border-radius: 50px;\n  background: #009FE8;\n  color: white;\n  outline: none;\n  font-weight: 700;\n}\n.modal-footer {\n  text-align: center;\n}\n.matInput{\n  display: block;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/reusable/input-promo-modal/input-promo-modal.component.css
// module id = ./src/app/shared/reusable/input-promo-modal/input-promo-modal.component.css
// module chunks = main